import React from "react";
import s from "./style.module.scss";
import PropTypes from "prop-types";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";
import { FORMATING_TYPE } from "../../constants";
import useStyles from "./styles";
const QuestionPreview = (props) => {
  const classes = useStyles();

  const { t } = useTranslation("surveyTaker");
  return (
    <>
      <div className={s.questionPreviewContainer}>
        {props.questionId ? (
          <label htmlFor={props.questionId}>
            {props.styleNps ? (
              <div
                className={
                  props.required ? s.requiredQuestionNps : s.questionNps
                }
              >
                {/* <div dangerouslySetInnerHTML={{ __html: props.question }}></div> */}
                <RenderQuestionTitle
                  isMatrix={props.matrix}
                  content={{ __html: props.question }}
                />
              </div>
            ) : (
              <div className={props.required ? s.requiredQuestion : s.question}>
                {/* <div dangerouslySetInnerHTML={{ __html: props.question }}></div> */}
                <RenderQuestionTitle
                  isMatrix={props.matrix}
                  content={{ __html: props.question }}
                />
              </div>
            )}
            {/* {props.required ? (
            <span aria-label="required question" className={s.required}>
              *
            </span>
          ) : (
            ""
          )} */}
          </label>
        ) : props.styleNps ? (
          <div
            className={props.required ? s.requiredQuestionNps : s.questionNps}
          >
            {/* <div dangerouslySetInnerHTML={{ __html: props.question }}></div> */}
            <RenderQuestionTitle
              className={props.required ? s.requiredQuestionNps : s.questionNps}
              isMatrix={props.matrix}
              content={{ __html: props.question }}
            />
          </div>
        ) : (
          <div className={props.required ? s.requiredQuestion : s.question}>
            {/* <div dangerouslySetInnerHTML={{ __html: props.question }}></div> */}
            <RenderQuestionTitle
              isMatrix={props.matrix}
              content={{ __html: props.question }}
            />
          </div>
        )}
        {props.required ? <span className={s.required}>*</span> : ""}
        {props.helperText && (
          <div
            id={props.questionId ? props.questionId + "-desc" : "helper-text"}
            className={s.helperTextRow}
          >
            {props.helperText}
          </div>
        )}
      </div>
      {props.formattingType &&
        props.formattingType === FORMATING_TYPE.PASS_THROUGH_LINK && (
          <div
            className={`${classes.ptlMessageContainer} ${
              !props.questionType && classes.ptlContainerWidth
            }`}
          >
            <div className={classes.ptlMessageIconContainer}>
              <InfoOutlinedIcon
                className={classes.ptlMessageInfoStyle}
              ></InfoOutlinedIcon>
            </div>
            <div className={classes.ptlMessageTextContainer}>
              {t("surveyTaker:ptlMessage")}
            </div>
          </div>
        )}
    </>
  );
};

const RenderQuestionTitle = ({ isMatrix, className, content }) => {
  if (isMatrix) {
    return <div className={className} dangerouslySetInnerHTML={content} />;
  }
  return <h1 dangerouslySetInnerHTML={content} className={s.h1} />;
};

QuestionPreview.propTypes = {
  question: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  matrix: PropTypes.bool,
};

export default QuestionPreview;
